document.addEventListener('DOMContentLoaded', () => {
    const { buttonName, pageName } = document.querySelector('script[data-button-name][data-page-name]').dataset;    
    const redirectButton = document.getElementById(buttonName);

    if (!redirectButton) {
        return;
    }

    redirectButton.addEventListener('click', () => {
        const redirectPage = sessionStorage.getItem(pageName);

        if (redirectPage) {
            window.location.href = redirectPage;
            return;
        }

        window.history.back();
    });
});
